import {
    AuthActionEnum,
    SetAuthAction,
    SetBoxesAction,
    SetCardBigSize,
    SetCards,
    SetCpuStoryAction,
    SetDeckEditorFilter,
    SetErrorAction, SetGlobalErrorAction, SetGlobalLoadingAction,
    SetInQueue,
    SetIsLoadingAction,
    SetMusicAction,
    SetNutakuBoxesAction,
    SetOpenBox,
    SetPromoSocilaAction,
    SetRouteAction,
    SetSystemMessage,
    SetTutorialAction,
    SetUniqIdAction,
    SetUserAction
} from "./types";
import {IUser} from "../../../models/IUser";
import {AppDispatch, RootState, store} from "../../index";
import UserService from "../../../api/UserService";
import {ITutorial} from "../../../models/ITutorial";
import {ICpuStory} from "../../../models/ICpuStory";
import {IMusic} from "../../../models/IMusic";
import {IBoxArray} from "../../../models/IBoxArray";
import {MusicService} from "../../../services/MusicService";
import {INutakuBoxArray} from "../../../models/INutakuBoxArray";
import {ISystemMessage} from "../../../models/ISystemMessage";
import {IDeckEditorFilter} from "../../../models/IDeckEditorFilter";
import {Preloader} from "../../../services/Preloader";
import {config} from "../../../config";
import {IVersionError} from "../../../models/IVersionError";
import {sendUrlParams} from "../../../utils/sendUrlParams";

export const AuthActionCreators = {
    setUser: (user: IUser): SetUserAction => ({type: AuthActionEnum.SET_USER, payload: user}),
    setTutorial: (tutorial: ITutorial): SetTutorialAction => ({type: AuthActionEnum.SET_TUTORIAL, payload: tutorial}),
    setRoute: (payload: string): SetRouteAction => ({type: AuthActionEnum.SET_ROUTE, payload: payload}),
    setUniqId: (payload: string): SetUniqIdAction => ({type: AuthActionEnum.SET_UNIQ_ID, payload}),
    setGlobalError: (payload: IVersionError | string | null): SetGlobalErrorAction => ({type: AuthActionEnum.SET_GLOBAL_ERROR, payload: payload}),
    setGlobalLoading: (payload: boolean): SetGlobalLoadingAction => ({type: AuthActionEnum.SET_GLOBAL_LOADING, payload: payload}),
    setIsAuth: (auth: boolean): SetAuthAction => ({type: AuthActionEnum.SET_AUTH, payload: auth}),
    setIsLoading: (payload: boolean): SetIsLoadingAction => ({type: AuthActionEnum.SET_IS_LOADING, payload}),
    setError: (payload: string): SetErrorAction => ({type: AuthActionEnum.SET_ERROR, payload}),
    setCpuStory: (cpuStory: ICpuStory): SetCpuStoryAction => ({type: AuthActionEnum.SET_CPU_STORY, payload: cpuStory}),
    setMusic: (payload: IMusic): SetMusicAction => ({type: AuthActionEnum.SET_MUSIC, payload}),
    setBoxes: (payload: IBoxArray): SetBoxesAction => ({type: AuthActionEnum.SET_BOXES, payload}),
    setNutakuBoxes: (payload: INutakuBoxArray): SetNutakuBoxesAction => ({
        type: AuthActionEnum.SET_NUTAKU_BOXES,
        payload
    }),
    setOpenBox: (payload: any): SetOpenBox => ({type: AuthActionEnum.SET_OPENBOX, payload}),
    setCards: (payload: any): SetCards => ({type: AuthActionEnum.SET_CARDS, payload}),
    setPromoSocial: (payload: boolean): SetPromoSocilaAction => ({type: AuthActionEnum.SET_PROMO_SOCIAL, payload}),
    setCardBigSize: (payload: any): SetCardBigSize => ({type: AuthActionEnum.SET_CARD_BIG_SIZE, payload}),
    setSystemMessage: (payload: ISystemMessage): SetSystemMessage => ({
        type: AuthActionEnum.SET_SYSTEM_MESSAGE,
        payload: {
            actionCancel: null,
            ...payload
        }
    }),
    setInQueue: (payload: boolean): SetInQueue => ({type: AuthActionEnum.SET_IN_QUEUE, payload}),
    setDeckEditorFilter: (payload: IDeckEditorFilter): SetDeckEditorFilter => ({
        type: AuthActionEnum.SET_DECK_EDITOR_FILTER,
        payload
    }),

    setDeck: (deckId: number) => async (dispatch: AppDispatch) => {
        dispatch(AuthActionCreators.setIsLoading(true));
        try {
            const response = await UserService.setDeck(deckId);

            if (response.status === 200) {
                dispatch(AuthActionCreators.setUser(response.data));
            }
        } catch (e) {
            console.log('Set Deck error');
        }

        dispatch(AuthActionCreators.setIsLoading(false));
    },
    createDeck: (name: string) => async (dispatch: AppDispatch) => {
        dispatch(AuthActionCreators.setIsLoading(true));
        try {
            const response = await UserService.createDeck(name);

            if (response.status === 200) {
                dispatch(AuthActionCreators.setUser(response.data));
            }
        } catch (e) {
            console.log('create deck error');
        }

        dispatch(AuthActionCreators.setIsLoading(false));
    },
    editDeck: (id: number, name: string) => async (dispatch: AppDispatch) => {
        dispatch(AuthActionCreators.setIsLoading(true));
        try {
            const response = await UserService.editDeck(id, name);

            if (response.status === 200) {
                dispatch(AuthActionCreators.setUser(response.data));
            }
        } catch (e) {
            console.log('create deck error');
        }

        dispatch(AuthActionCreators.setIsLoading(false));
    },
    deleteDeck: (id: number) => async (dispatch: AppDispatch) => {
        dispatch(AuthActionCreators.setIsLoading(true));
        try {
            const response = await UserService.deleteDeck(id);

            if (response.status === 200) {
                dispatch(AuthActionCreators.setUser(response.data));
            }
        } catch (e) {
            console.log('create deck error');
        }

        dispatch(AuthActionCreators.setIsLoading(false));
    },
    removeCard: (cardId: number) => async (dispatch: AppDispatch) => {
        dispatch(AuthActionCreators.setIsLoading(true));
        try {
            const response = await UserService.removeCard(cardId);

            if (response.status === 200) {
                dispatch(AuthActionCreators.setUser(response.data));
            }
        } catch (e) {
            console.log('remove card error');
        }

        dispatch(AuthActionCreators.setIsLoading(false));
    },
    addCard: (cardId: any) => async (dispatch: AppDispatch) => {
        dispatch(AuthActionCreators.setIsLoading(true));

        try {
            const response = await UserService.addCard(cardId);

            if (response.status === 200) {
                dispatch(AuthActionCreators.setUser(response.data));
            }
        } catch (e) {
            console.log('add card error');
        }

        dispatch(AuthActionCreators.setIsLoading(false));

        // Tutorial battle step
        const state = store.getState();
        let tutorial = state.auth.tutorial;
        if (tutorial.isActive === false) {
            return;
        }
        if (tutorial.step === 'ClickAdd130') {
            tutorial.step = 'ClickHome140';
        }

        AuthActionCreators.setTutorial(tutorial);
        ///
    },
    openBox: (boxId: number, callback: any) => async (dispatch: AppDispatch) => {
        dispatch(AuthActionCreators.setIsLoading(true));

        try {
            const response = await UserService.openBox(boxId);
            if (response.status === 200) {
                dispatch(AuthActionCreators.setOpenBox(response.data));
                callback();
            }
        } catch (e) {
            console.log('open box error');
        }

        dispatch(AuthActionCreators.setIsLoading(false));
    },
    craftCard: (cardId: number, callback: any) => async (dispatch: AppDispatch) => {
        dispatch(AuthActionCreators.setIsLoading(true));

        try {
            const response = await UserService.craftCard(cardId);
            if (response.status === 200) {
                dispatch(AuthActionCreators.setOpenBox(response.data));
                callback();
            }
        } catch (e) {
            console.log('craft card error');
        }

        dispatch(AuthActionCreators.setIsLoading(false));
    },
    /* activateSeasonPass: (callback: any, systemMessage: any) => async (dispatch: AppDispatch) => {

         dispatch(AuthActionCreators.setIsLoading(true));
         try {
             const response = await UserService.activateSeasonPass();
             // @ts-ignore
             if (response.status === 200) {
                 callback();
                 systemMessage({
                     isVisible: true,
                     type: 'info',
                     text: 'Season pass activated!',
                     action: null
                 });
             }
         } catch (e) {

             console.log('open box error');
         }

         dispatch(AuthActionCreators.setIsLoading(false));

     }, */
    getCards:
        () => async (dispatch: AppDispatch) => {
            {
                const response = await UserService.getCards();
                dispatch(AuthActionCreators.setCards(response.data));
            }
        },
    getBoxes:
        () => async (dispatch: AppDispatch) => {
            {
                const response = await UserService.getBoxes();
                dispatch(AuthActionCreators.setBoxes(response.data));

            }
        },
    getNutakuBoxes:
        () => async (dispatch: AppDispatch) => {
            {
                const response = await UserService.getNutakuBoxes();
                dispatch(AuthActionCreators.setNutakuBoxes(response.data));

            }
        },
    setNutakuNickname: (username: string) => async (dispatch: AppDispatch) => {
        await UserService.editUser('', '', username);
    },
    editUser:
        (login: string, password: string, username: string) => async (dispatch: AppDispatch) => {
            {
                dispatch(AuthActionCreators.setIsLoading(true));

                const response = await UserService.editUser(login, password, username);

                if (response.data.user) {
                    const response = await UserService.updateUser();
                    // @ts-ignore
                    if (typeof response.data.id !== 'undefined') {
                        // @ts-ignore
                        dispatch(AuthActionCreators.setUser(response.data));
                        dispatch(AuthActionCreators.setIsAuth(true));
                        dispatch(AuthActionCreators.setError('no error'));

                        // @ts-ignore
                     //   await dispatch(AuthActionCreators.authUserByLoginAndPass(login, password));

                    } else {
                        dispatch(AuthActionCreators.setError('Network error'));
                    }
                }

                if (response.data.error !== undefined) {
                    dispatch(AuthActionCreators.setError(response.data.error));
                }
                dispatch(AuthActionCreators.setIsLoading(false));
            }
        },
    resetPassword:
        (email: string) => async (dispatch: AppDispatch) => {
            dispatch(AuthActionCreators.setIsLoading(true));
            try {
                const response = await UserService.resetPassword(email);

                if (response.status === 200 && typeof response.data.sucsses !== 'undefined') {

                    return true;
                }

                throw response.data?.error ?? new Error("Email not found");
            } catch (e) {

                throw e;
            } finally {
                dispatch(AuthActionCreators.setIsLoading(false));
            }
        },
    applyPromocode:(promocode: string) => async (dispatch: AppDispatch) => {
        dispatch(AuthActionCreators.setIsLoading(true));

        const response = await UserService.applyPromocode(promocode);

        dispatch(AuthActionCreators.setIsLoading(false));

        return response;
     },
    authUserByLoginAndPass:
        (login: string, password: string) => async (dispatch: AppDispatch) => {
            dispatch(AuthActionCreators.setIsLoading(true));
            try {
                const response = await UserService.authUserByLoginAndPass(login, password);

                if(typeof response.data.error !== 'undefined' && response.data.error === 'version_mismatch') {

                    dispatch(AuthActionCreators.setGlobalError(response.data));

                    return;
                }

                if (response.status === 200 && typeof response.data.id !== 'undefined') {
                    dispatch(AuthActionCreators.setUser(response.data));
                    MusicService.playMenuMusic();
                    localStorage.setItem('jwtToken', response.data.jwtToken);
                    return response.data; // <-- resolve to caller
                }

                // normalize and throw an error
                throw response.data?.error ?? new Error("Authentication Error");
            } catch (e) {
                // optionally dispatch a failure action here
                throw e; // <-- rethrow so caller can catch
            } finally {
                dispatch(AuthActionCreators.setIsLoading(false)); // <-- ensure off even on error
            }
        },
    authNewUser:
        () => async (dispatch: AppDispatch) => {
            {
                dispatch(AuthActionCreators.setIsLoading(true));

                const response = await UserService.authNewUser();

                if(typeof response.data.error !== 'undefined' && response.data.error === 'version_mismatch') {

                    dispatch(AuthActionCreators.setGlobalError(response.data));

                    return;
                }


                dispatch(AuthActionCreators.setUser(response.data));

                if (response.data.tutorial === true) {
                    MusicService.playMenuMusic();
                    dispatch(AuthActionCreators.setTutorial({isActive: true, step: 'Welcome10'}));
                } else {
                    MusicService.playMenuMusic();
                }

                localStorage.setItem('jwtToken', response.data.jwtToken);

                dispatch(AuthActionCreators.setIsLoading(false));
            }
        },
    updateUser: // This is REFRESH user!!
        () => async (dispatch: AppDispatch) => {
            {
                const response = await UserService.updateUser();

                if(typeof response.data.error !== 'undefined' && response.data.error === 'version_mismatch') {

                    dispatch(AuthActionCreators.setGlobalError(response.data));

                    return;
                }

                // @ts-ignore
                if (typeof response.data.id !== 'undefined') {
                    // @ts-ignore
                    dispatch(AuthActionCreators.setUser(response.data));
                    return response.data;
                } else {
                    localStorage.removeItem('jwtToken');
                }

            }
        },
    logout:
        () => async (dispatch: AppDispatch) => {
            localStorage.removeItem('auth');
            localStorage.removeItem('user');
            localStorage.removeItem('nickname');
            localStorage.removeItem('jwtToken');
            dispatch(AuthActionCreators.setUser({} as IUser));
            dispatch(AuthActionCreators.setIsAuth(false));

            window.location.reload();
        },
    startLoadingGame: () => async (dispatch: AppDispatch, getState: () => RootState) => {
        const { globalError,uniqId, user } = getState().auth; // or wherever it's stored
        if (globalError !== null) {
            return; // stop, do nothing
        }

        dispatch(AuthActionCreators.setGlobalLoading(true));

        await dispatch(AuthActionCreators.getCards() as any);

        const response = await UserService.getFiles();

        await dispatch(AuthActionCreators.getNutakuBoxes() as any);
        Preloader.load(response);

        let loadingTimeOut = config.LOADING_TIMEOUT_MS;
        if (config.isAndroid) {
            loadingTimeOut = config.LOADING_TIMEOUT_MS_ANDROID;
        }

        setTimeout(async () => {
            sendUrlParams(uniqId, user.id);
            dispatch(AuthActionCreators.setIsAuth(true));
            dispatch(AuthActionCreators.setRoute('home'));
            dispatch(AuthActionCreators.setGlobalLoading(false));
        }, loadingTimeOut);
    }
}
